

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function(){

		var _this = this , i ;

		//---------------------------------------------------------------------------------

		SE.volume(0.05);

		if( /sample/.test(location.search) ){
			var temp = document.getElementsByClassName( "goodjobContainer" )[0];
			temp.className = temp.className + " sample";
		}




		// カバーの横持ち案内の表示処理
		var cover = document.getElementsByClassName("cover")[0];
		console.log(navigator.userAgent);
		cover.pcClassName = cover.className + " pc" ;
		if( /iphone|ipad|ipod/i.test(navigator.userAgent) ){
			cover.className = cover.className + " ios" ;
		}else if( /android/i.test(navigator.userAgent) ){
			cover.className = cover.className + " android" ;
		}else{
			cover.className = cover.className + " pc" ;
		}
		cover.defClassName = cover.className ;
		cover.onResize = function(evt){
			if( cover.isNone ){
				cover.className = "cover none";
				return ;
			}

			if( window.innerWidth > window.innerHeight ){
				cover.className = cover.pcClassName ;
			}else {
				cover.className = cover.defClassName ;
			}
		};
		window.addEventListener("resize", cover.onResize);
		cover.onResize();


		// 各機能の初期化処理
		var goodjob = document.getElementsByClassName("goodjobButton");
		// var aa = new GoodjobEffect( goodjob[0] );
		for( i = 0 ; i < goodjob.length ; i++ ){
			new GoodjobButton( goodjob[i] );
		}
		new GoodjobButtonSample( document.getElementsByClassName("goodjobButtonSample")[0] );


		var loadJSON = function(){
			$.ajax("/monsterstrike/grandprix/championship2018/live/assets_mt/json/config.json",{
				dataType:"json",
				success:function(data,type,request){
					YouTubeLive.video_id = data.video_id ;
					YouTubeLive.cover_img = data.cover_img ;
					init();
				},
				error:function(request){
					setTimeout(loadJSON ,1000 );
				}
			});
		}
		loadJSON();

		//

		var intro ;
		var init = function(){
			intro = document.getElementsByClassName("overlay-intro")[0];
			intro.style.opacity = 1;
			intro.onClick = function(evt){
				intro.removeEventListener("click", intro.onClick);
				intro.style.pointerEvents = "none" ;
				Call.remove(intro);
				Tween.add( intro.style, {opacity:0, time:0.3, transition:"linear"},{
					onComplete:function(){
						intro.parentNode.removeChild(intro);
					}
				});
			}
			intro.addEventListener("click", intro.onClick);
			Call.add(intro, {time:2.5}, {onComplete:intro.onClick});


			new StateManager();
			new PollingRequest();
			new YouTubeLive();
			new GoodjobCount();
			new Message();
		}
	}

	var SE = new Howl( {src: ['./assets/index/audio/cheer.mp3']} );


//------------------------------------------------------------------------------------------------------------------------------


	/**
	 * APIからうけとったデータより現在の状態を判別して、それぞれの機能クラスに処理を伝達するクラス
	 */
	var StateManager = function(){

		var prevData = {
			status:null
		};

		var State = {}
		State.PREPARATION = -1;
		State.STANDBY = 0;
		State.GJ_ENABLED = 1;
		State.GJ_DISABLED = 2;

		StateManager.check = function( applyData ){

			switch( applyData.status ){

				case State.STANDBY : // 未開催

					if( prevData.status == State.STANDBY ){
						/**
					 	* スタンバイからスタンバイの場合は、以降の処理を省略する
					 	*/
						return ;
					}

					Message.show( Message.STANDBY );
					GoodjobCount.hide();
					GoodjobCount.setEnabled( false );
					PollingRequest.postSudden();
					break ;


				case State.GJ_ENABLED : // 開催集計中
				case State.GJ_DISABLED : // 開催中集計停止

					if( !prevData.status || prevData.status == State.STANDBY ){
						/**
					 	* スタンバイから以降したて
					 	*/
						Message.hide();
						GoodjobCount.init();
						GoodjobCount.show();
						GoodjobCount.applyAPIData(applyData);

					} else if( prevData.tournament_id == applyData.tournament_id && prevData.game_id == applyData.game_id ){
						/**
					 	* 同じ試合が継続している
					 	*/
						GoodjobCount.applyAPIData(applyData);

					} else{
						/**
					 	* 違う試合に移行した
					 	*/
						GoodjobCount.init();
						GoodjobCount.applyAPIData(applyData);
						PollingRequest.postSudden();
					}

					GoodjobCount.setEnabled( applyData.status == State.GJ_ENABLED );
					break ;
			}

			prevData = applyData ;
		}

	}


//------------------------------------------------------------------------------------------------------------------------------

/**
 * 何だか楽しくなるクラス
 * @param {string} arg1 もっと面白くする引数
 * @param {Array.<number>} arg2 処理される数値のリスト
 * @constructor
 * @extends {goog.Disposable}
 */

 /**
 * MyClass のインスタンスを操作し、何かを返します。
 * @param {project.MyClass} obj 折り返して2行にしなければならないほど
 *     長いコメントが続く、MyClass のインスタンス
 * @return {boolean} 何かが起きたかどうか
 */


 	/**
	 * メッセージを表示するクラス
	 */
 	var Message = function( ){

 		var root = document.getElementsByClassName( "message" )[0] ;
 		root.style.opacity = 1;
 		root.viaible = true ;

 		var text = {};
 		text.preparation = root.getElementsByClassName("preparation")[0];
 		text.preparation.style.opacity = 1;
 		text.standby = root.getElementsByClassName("standby")[0];
 		text.standby.style.opacity = 0;

 		Message.PREPARATION = "preparation";
 		Message.STANDBY = "standby";
 		Message.type = Message.PREPARATION;
 		Message.focus = text[Message.type];

 		Message.show = function( settingType ){

			root.setAttribute("is-enabled","");

 			if( settingType != undefined && Message.type != settingType ){
 				Tween.add.update( Message.focus.style, {opacity:0, time:0.15, transition:"linear"});
 				Message.type = settingType ;
 				Message.focus = text[Message.type];
 				Tween.add.update( Message.focus.style, {opacity:1, time:0.15, transition:"linear", delay:0.15});
 			}
 			if( root.viaible ){
 				root.viaible = true ;
 				Tween.add( root.style, {opacity:1, time:0.2, transition:"linear"});
 			}
 		}
 		Message.hide = function( ){

			root.removeAttribute("is-enabled");
 			Tween.add( root.style, {opacity:0, time:0.2, transition:"linear"});
 		}
 	}




	/**
	 * グッジョブ数のカウントを管理するクラス
	 */
	var GoodjobCount = function( ){

		var i = 0, _this = this, temp;


		var root = document.getElementsByClassName( "countList" )[0];
		root.style.opacity = 0;
		GoodjobCount.show = function(){
			root.style.pointerEvents = "";
 			Tween.add( root.style, {opacity:1, time:0.2, transition:"linear"});
 		}
 		GoodjobCount.hide = function(){
 			root.style.pointerEvents = "none";
 			Tween.add( root.style, {opacity:0, time:0.2, transition:"linear"});
 		}
 		GoodjobCount.teamNameGold = root.getElementsByClassName("teamNameGold")[0];
 		GoodjobCount.teamNamePlatinum = root.getElementsByClassName("teamNamePlatinum")[0];



		var goodjobCount = root.getElementsByClassName( "goodjobCount" );
		for( i = 0 ; i < goodjobCount.length ; i++ ){
			temp = goodjobCount[i];
			temp.type = goodjobCount[i].getAttribute("data-type");
			temp.index = goodjobCount[i].getAttribute("data-index");
			temp.addedCount = 0;
			temp.totalCount = 0;
			temp.css = new DirectCSS( temp ) ;
			temp.name = temp.previousElementSibling ;
			GoodjobCount[temp.type][temp.index] = temp ;
		}


		GoodjobCount.add = function(type, index){

			temp = GoodjobCount[type][index] ;
			temp.addedCount ++ ;
			temp.totalCount ++ ;
			temp.innerHTML = temp.totalCount ;
			temp.css["font-weight"] = "bold";

			Tween.add.update( temp.css, {scaleX:1.6, scaleY:1.6, time:0.15, transition:"easeOutCubic"}, {onUpdate:temp.css.update} )
				.chain( {scaleX:1, scaleY:1, time:0.15, transition:"easeInCubic"}, {onUpdate:temp.css.update,
				onComplete:function(){
					temp.css["font-weight"] = "normal";
					// temp.css.update();
					temp.css.remove();
				}} ) ;

			console.log(type, index, temp.addedCount);
		}


		/*
		{
		  status:1 (or 2),
		  tournament_id: 10,
		  game_id: 10,
		  teams: [
		    {
		        name: “チームA”,
		        member:[“メンバー1”, “メンバー2”, “メンバー3”, “メンバー4”],
		        goodjob: [9923, 259, 123, 4932]
		    },
		    {
		        name: “チームB”,
		        member:[“メンバー5”, “メンバー6”, “メンバー7”, “メンバー8”],
		        goodjob: [223, 159, 9123, 8932]
		    }
		  ]
		}
		*/
		GoodjobCount.applyAPIData = function(data){

			// グッジョブ数
			var goldData = data.teams[0] ;
			var platinumData = data.teams[1] ;

			GoodjobCount.teamNameGold.innerHTML = goldData.name;
 			GoodjobCount.teamNamePlatinum.innerHTML = platinumData.name;

			for( i = 0 ; i < goldData.member.length ; i++ ){

				// goldData.goodjob[i] = GoodjobCount.gold[i].totalCount + Math.ceil( Math.random()*200 ) ;

				temp = GoodjobCount.gold[i] ;
				temp.name.textContent = goldData.member[i] ;

				if( temp.totalCount < goldData.goodjob[i] ){
					temp.totalCount = goldData.goodjob[i] ;
					temp.innerHTML = temp.totalCount ;

					Tween.add.update( temp.css, {scaleX:1.5, scaleY:1.5, time:0.15, transition:"easeOutCubic"}, {onUpdate:temp.css.update} )
						.chain( {scaleX:1, scaleY:1, time:0.15, transition:"easeInCubic"}, {onUpdate:temp.css.update, onComplete:temp.css.remove} ) ;
				}
			}
			for( i = 0 ; i < platinumData.member.length ; i++ ){

				// platinumData.goodjob[i] = GoodjobCount.platinum[i].totalCount + Math.ceil( Math.random()*200 ) ;

				temp = GoodjobCount.platinum[i] ;
				temp.name.textContent = platinumData.member[i] ;

				if( temp.totalCount < platinumData.goodjob[i] ){
					temp.totalCount = platinumData.goodjob[i] ;
					temp.innerHTML = temp.totalCount ;

					Tween.add.update( temp.css, {scaleX:1.5, scaleY:1.5, time:0.15, transition:"easeOutCubic"}, {onUpdate:temp.css.update} )
						.chain( {scaleX:1, scaleY:1, time:0.15, transition:"easeInCubic"}, {onUpdate:temp.css.update, onComplete:temp.css.remove} ) ;
				}
			}


			// 試合の情報
			GoodjobCount.tournament_id = data.tournament_id ;
			GoodjobCount.game_id = data.game_id ;
		}


		GoodjobCount.init = function(){

			GoodjobCount.tournament_id = null;
			GoodjobCount.game_id = null;

			for( i = 0 ; i < GoodjobCount.gold.length ; i++ ){
				GoodjobCount.gold[i].addedCount = 0;
				GoodjobCount.gold[i].totalCount = 0;
				GoodjobCount.gold[i].innerHTML = 0;
			}
			for( i = 0 ; i < GoodjobCount.platinum.length ; i++ ){
				GoodjobCount.platinum[i].addedCount = 0;
				GoodjobCount.platinum[i].totalCount = 0;
				GoodjobCount.platinum[i].innerHTML = 0;
			}
		}
		GoodjobCount.init.addedCount = function(){

			for( i = 0 ; i < GoodjobCount.gold.length ; i++ ){
				GoodjobCount.gold[i].addedCount = 0;
			}
			for( i = 0 ; i < GoodjobCount.platinum.length ; i++ ){
				GoodjobCount.platinum[i].addedCount = 0;
			}
		}

		var goodJobContainer = document.getElementsByClassName("goodjobContainer")[0];
		var countList = document.getElementsByClassName("countList")[0];
		GoodjobCount.enabled = false ;
		GoodjobCount.setEnabled = function( boolean ){

			if( GoodjobCount.enabled == boolean ){
				return ;
			}

			GoodjobCount.enabled = boolean ;

			if( GoodjobCount.enabled ){
				goodJobContainer.className = goodJobContainer.className.replace( /\sis\-disabled/ , "" ) ;
				countList.className = countList.className.replace( /\sis\-disabled/ , "" ) ;
			} else{
				goodJobContainer.className = goodJobContainer.className + " is-disabled" ;
				countList.className = countList.className + " is-disabled" ;
			}
		}


		GoodjobCount.createPostData = function(){

			if( !GoodjobCount.tournament_id || !GoodjobCount.game_id ){
				return null ;
			}

			var count = 0 ;

			var goldArr = [];
			for( i = 0 ; i < GoodjobCount.gold.length ; i++ ){
				count += GoodjobCount.gold[i].addedCount;
				goldArr.push( GoodjobCount.gold[i].addedCount );
				GoodjobCount.gold[i].addedCount = 0 ;
			}
			var platinumArr = [];
			for( i = 0 ; i < GoodjobCount.platinum.length ; i++ ){
				count += GoodjobCount.platinum[i].addedCount;
				platinumArr.push( GoodjobCount.platinum[i].addedCount );
				GoodjobCount.platinum[i].addedCount = 0 ;
			}

			if( count == 0 ){
				return null ;
			}

			var obj = {
				tournament_id:GoodjobCount.tournament_id,
				game_id:GoodjobCount.game_id,
				team1:goldArr.join(","),
				team2:platinumArr.join(","),
			}
			return obj;
		}
	}
	GoodjobCount.tournament_id = null;
	GoodjobCount.game_id = null;
	GoodjobCount.gold = [] ;
	GoodjobCount.platinum = [] ;


	/**
	 * グッジョブボタンを管理するクラス
	 */
	var GoodjobButton = function( target ){

		var _this = this, i ;

		var goodjobEffect = this.effect = new GoodjobEffect( target.getElementsByClassName("goodjob")[0] );
		var type = target.getAttribute("data-type") ;
		var index = Number(target.getAttribute("data-index")) ;

		target.onClick = function(evt){
			evt.preventDefault();

			if( GoodjobButton.isAnimate[type][index] ){
				return ;
			}
			GoodjobButton.isAnimate[type][index] = true ;
			Call.add(_this, {time:1.3}, {onComplete:animateUnlock});

			// goodjobEffect.act();
			SE.play();
			var arr = GoodjobButton[type][index] ;
			for( i = 0 ; i < arr.length ; i++ ){
				arr[i].effect.act();
			}

			GoodjobCount.add(type, index);
		}
		target.addEventListener("click", target.onClick);


		var animateUnlock = function(){
			GoodjobButton.isAnimate[type][index] = false ;
		};


		GoodjobButton[type][index].push(this);
	}
	GoodjobButton.gold = [[], [], [], []];
	GoodjobButton.platinum = [[], [], [], []];
	GoodjobButton.isAnimate = {
		gold:[false, false, false, false],
		platinum:[false, false, false, false],
	}
	var GoodjobButtonSample = function( target ){

		var _this = this, i ;

		var goodjobEffect = this.effect = new GoodjobEffect( target.getElementsByClassName("goodjob")[0] );
		_this.isAnimate = false ;

		target.onClick = function(evt){
			evt.preventDefault();

			if( _this.isAnimate ){
				return ;
			}
			_this.isAnimate = true ;
			Call.add(_this, {time:1.3}, {onComplete:animateUnlock});

			SE.play();
			
			_this.effect.act();

			var date = new Date();

			Tracking.send("サンプルグッジョブ",(date.getMonth()+1)+"月"+date.getDate()+"日",date.getHours()+"時");
		}
		target.addEventListener("click", target.onClick);

		var animateUnlock = function(){
			_this.isAnimate = false ;
		};
	}


	/**
	 *
	 *
	 */
	var GoodjobEffect = function( target ){

		var _this = this, i ;

		var icon = new DirectCSS( target.getElementsByClassName("icon")[0], {scaleX:1, scaleY:1} );
		// var iconColor = new DirectCSS( target.getElementsByClassName("iconColor")[0], {scaleX:1, scaleY:1, opacity:0} );
		// var txtMini = new DirectCSS( target.getElementsByClassName("txtMini")[0], {y:5, opacity:0} );

		// var bg = new DirectCSS( target.getElementsByClassName("bg")[0], {scaleX:1, scaleY:1} );
		var gesture = new DirectCSS( target.getElementsByClassName("gesture")[0], {scaleX:0, scaleY:0, rotation:0} );
		var spark = new DirectCSS( target.getElementsByClassName("spark")[0], {scaleX:0, scaleY:0} );
		var plus1 = new DirectCSS( target.getElementsByClassName("plus1")[0], {scaleX:0.75, scaleY:0.75, opacity:0} );
		var txt1 = new DirectCSS( target.getElementsByClassName("txt1")[0], {scaleX:0, scaleY:0} );
		var txt2 = new DirectCSS( target.getElementsByClassName("txt2")[0], {scaleX:0, scaleY:0} );
		var txt3 = new DirectCSS( target.getElementsByClassName("txt3")[0], {scaleX:0, scaleY:0} );

		// var isAnimate = false ;

		_this.act = function(){

			// if( isAnimate ){
			// 	return ;
			// }
			// isAnimate = true ;

			// Tween.add.update( icon, {scaleX:0, scaleY:0, time:0.15, transition:"easeInQuart"}, {onUpdate:icon.update} )
				// .chain( {scaleX:1, scaleY:1, time:0.15, transition:"easeOutQuart", delay:1.2}, {onUpdate:icon.update} ) ;

			Tween.add.update( icon, {rotation:-5, time:0.05, transition:"easeOutQuart", delay:0}, {onUpdate:icon.update} )
				.chain( {rotation:18, y:0, time:0.15, transition:"easeInQuart", delay:0}, {onUpdate:icon.update} )
				.chain( {rotation:0, time:0.1, transition:"easeOutQuart", delay:0}, {onUpdate:icon.update} )
				.chain( {/*x:-12, y:0,*/ time:0.15, transition:"linear", delay:0.4}, {onUpdate:icon.update} );
			// gesture.scaleX = 0.7;
			// gesture.scaleY = 0.7;
			// gesture.x = -15;
			// gesture.y = 5;
			// gesture.rotation = 0;
			// gesture.opacity = 0;
			// gesture.update();
			// Tween.add.update( gesture, {opacity:1, x:12, y:-5, time:0.2, transition:"easeOutQuad"}, {onUpdate:gesture.update} )
			// 	.chain( {rotation:-5, time:0.05, transition:"easeOutQuart", delay:0.05}, {onUpdate:gesture.update} )
			// 	.chain( {rotation:18, y:-5, time:0.15, transition:"easeInQuart", delay:0}, {onUpdate:gesture.update} )
			// 	.chain( {rotation:0, time:0.1, transition:"easeOutQuart", delay:0}, {onUpdate:gesture.update} )
			// 	.chain( {opacity:0, time:0.15, transition:"linear", delay:0.4}, {onUpdate:gesture.update} );
				// .chain( {scaleX:1.25, scaleY:1.25, rotation:15, time:0.1, transition:"easeOutCubic", delay:0.02}, {onUpdate:gesture.update} )
				// .chain( {scaleX:1, scaleY:1, rotation:0, time:0.15, transition:"easeInCubic", delay:0}, {onUpdate:gesture.update} )
				// .chain( {scaleX:0, scaleY:0,time:0.15, transition:"easeInCubic", delay:0.4+0.1}, {onUpdate:gesture.update} );

			spark.x = -5;
			// Tween.add.update( spark, {x:5, time:0.4, transition:"linear", delay:0.45});
			Tween.add( spark, {scaleX:1, scaleY:1, time:0.1, transition:"easeOutQuart", delay:0.25}, {onUpdate:spark.update} )
				.chain( {scaleX:0, scaleY:0, time:0.15, transition:"easeInQuart", delay:0.1}, {onUpdate:spark.update} );

			plus1.y = 7;
			plus1.opacity = 0;
			plus1.update();
			Tween.add( plus1, {y:1, opacity:1, time:0.2, transition:"easeOutQuart", delay:0.2}, {onUpdate:plus1.update} )
				.chain( {y:-10, opacity:0, time:0.2, transition:"easeInQuart", delay:0.3}, {onUpdate:plus1.update} );
			

			// Tween.add.update( gesture, {scaleX:1, scaleY:1, time:0.1, transition:"easeOutQuad"}, {onUpdate:gesture.update} )
			// 	.chain( {rotation:-35, time:0.15, transition:"easeOutQuart", delay:0.0}, {onUpdate:gesture.update} )
			// 	.chain( {scaleX:1.25, scaleY:1.25, rotation:15, time:0.1, transition:"easeOutCubic", delay:0.02}, {onUpdate:gesture.update} )
			// 	.chain( {scaleX:1, scaleY:1, rotation:0, time:0.15, transition:"easeInCubic", delay:0}, {onUpdate:gesture.update} )
			// 	.chain( {scaleX:0, scaleY:0,time:0.15, transition:"easeInCubic", delay:0.4+0.1}, {onUpdate:gesture.update} );

			// Tween.add.update( bg, {scaleX:1.4, scaleY:1.4, time:0.15, transition:"easeOutQuart", delay:0.45}, {onUpdate:bg.update} )
			// 	.chain( {scaleX:1, scaleY:1, time:0.1, transition:"easeInQuad", delay:0}, {onUpdate:bg.update} )
			// 	.chain( {scaleX:0, scaleY:0, time:0.15, transition:"easeInQuart", delay:0.35+0.1}, {onUpdate:bg.update} );

			// Tween.add.update( txt1, {scaleX:1.5, scaleY:1.5, time:0.15, transition:"easeOutQuart", delay:0.35}, {onUpdate:txt1.update} )
			// 	.chain( {scaleX:1, scaleY:1, time:0.1, transition:"easeInQuad", delay:0}, {onUpdate:txt1.update} )
			// 	.chain( {scaleX:0, scaleY:0, time:0.15, transition:"easeInQuart", delay:0.5+0.1}, {onUpdate:txt1.update} );
			// Tween.add.update( txt2, {scaleX:1.4, scaleY:1.4, time:0.15, transition:"easeOutQuart", delay:0.4+0.2}, {onUpdate:txt2.update} )
			// 	.chain( {scaleX:1, scaleY:1, time:0.1, transition:"easeInQuad", delay:0}, {onUpdate:txt2.update} )
			// 	.chain( {scaleX:0, scaleY:0, time:0.15, transition:"easeInQuart", delay:0.3+0.1}, {onUpdate:txt2.update} );
			// Tween.add.update( txt3, {scaleX:1.6, scaleY:1.6, time:0.15, transition:"easeOutQuart", delay:0.4+0.25}, {onUpdate:txt3.update} )
			// 	.chain( {scaleX:1, scaleY:1, time:0.1, transition:"easeInQuad", delay:0}, {onUpdate:txt3.update} )
			// 	.chain( {scaleX:0, scaleY:0, time:0.15, transition:"easeInQuart", delay:0.25+0.1}, {onUpdate:txt3.update} );

			// Call.add(_this, {time:1.5}, {onComplete:function(){isAnimate=false;}});
			// Call.add(_this, {time:2}, {onComplete:_this.act});
		}


		// _this.act.mini = function(){

		// 	if( isAnimate ){
		// 		return ;
		// 	}

		// 	iconColor.opacity = 1 ;
		// 	Tween.add( iconColor, {scaleX:1.2, scaleY:1.2, time:0.2, transition:"easeInQuint"}, {onUpdate:iconColor.update} )
		// 		.chain( {scaleX:1, scaleY:1, time:0.2, transition:"easeOutQuint", delay:0}, {onUpdate:iconColor.update} )
		// 		.chain( {opacity:0, time:0.15, transition:"linear", delay:0}, {onUpdate:iconColor.update} ) ;

		// 	txtMini.opacity = 1 ;
		// 	txtMini.y = 5;
		// 	Tween.add( txtMini, {y:0, time:0.15, transition:"easeOutCubic"}, {onUpdate:txtMini.update} )
		// 		.chain( {opacity:0, y:-2, time:0.1, transition:"linear", delay:0.3}, {onUpdate:txtMini.update} ) ;

		// 	Call.add(_this, {time:Math.random()*4+1}, {onComplete:_this.act.mini});
		// }
		// Call.add(_this, {time:Math.random()*4}, {onComplete:_this.act.mini});
	}

//------------------------------------------------------------------------------------------------------------------------------


	var YouTubeLive = function() {

		var goodjobContainer = document.getElementsByClassName("goodjobContainer")[0];
		goodjobContainer.style.display = "none";


		var embed_youtube = document.getElementById("embed-youtube");
		// var video_id = "hI3LNOOBVwA" ;//サンプル
		// var video_id = "u-I9d0phyak";
		var video_id = YouTubeLive.video_id ;//当日
		// var video_id = "WXPb-1ygRqw" ;//ウェザーニュース

		var cover = document.getElementsByClassName("wrap-embed")[0].getElementsByClassName("cover")[0];
		var btn_reload = document.getElementsByClassName("btn-reload")[0] ;
		var isLivePlayed = false;


		//アンドロイド4系またはiOS10未満の場合動画を同一ページ内で再生させず、YouTubeサイトへ遷移させる
		var isRedirect = false ;
		var ua = navigator.userAgent;
		var version ;
		if( /android/i.test(navigator.userAgent) ) {
			version = parseFloat(ua.slice(ua.indexOf("Android")+8));
			console.log(version) ;
			if( version < 5 ) {
				isRedirect = true ;
			}
		}
		if( /iphone|ipad|ipod/i.test(navigator.userAgent) ) {
			ua.match(/os ([0-9]\w+){1,3}/ig) ;
		    version = Number( (RegExp.$1.replace(/_/g,'.')+'00').slice(0,3) ) ;
		    console.log(version) ;
		    if( version < 10 ) {
		    	isRedirect = true ;
		    }
		}


		if( YouTubeLive.cover_img && YouTubeLive.cover_img != "" ){
			cover.style.backgroundImage = "url("+YouTubeLive.cover_img+")";
			cover.style.pointerEvents = "none";
			cover.isNone = true ;
			cover.className = "cover none";
			// cover.getElementsByClassName("btn-play")[0].style.display = "none";
			return ;
		}
		


		//日本語本番のライブ配信URL
		// if( isRedirect ) {
		// 	cover.className = cover.className + " redirect" ;
		// 	cover.href = "https://www.youtube.com/watch?v="+video_id;//+"&start=1260" ;
		// 	cover.target = "_blank" ;

		// 	cover.onEvent = function(evt){
		// 		if(!isLivePlayed){
		// 			isLivePlayed = true ;
		// 			// Tracking.all("bingo-live-app-view", BingoCard.hash , "open-youtube " + new Date().getTime() );
		// 		}
		// 	}
		// 	cover.addEventListener("click",cover.onEvent);

		// 	btn_reload.style.display = "none";
		// 	return ;
		// }


		//scriptタグでYouTubeAPIを読み込む前に、
		//API読み込み完了後に行う埋め込みオブジェクト処理を、windowに対して設定しておく
		//windowに設定しておくことで、読み込み完了後callbackで自動で処理が呼び出される
		var video;
		window.onYouTubeIframeAPIReady = function(){
			video = new YT.Player('embed-youtube', {
				height: '360',
				width: '640',
				videoId: video_id,
				playerVars:{
					playsinline:1,
					controls:0,
					iv_load_policy:3,
					modestbranding:1,
					rel:0,
					showinfo:0
				},
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});
		}


		//YouTube埋め込みオブジェクトの準備ができたら、もしくは、別タブ遷移でPAUSE状態になっている場合、
		//どこでも画面にタッチしただけでストリーミングを開始させる
		var onTouchDocument = function(evt){
			switch(evt.type){
				case "touchstart":
					switch(video.getPlayerState()){

						case YT.PlayerState.PAUSED:
							video.stopVideo();
							video.playVideo();
							break;
					}
					break;
			}
		}
		var onPlayerReady = function(evt){
			// evt.target.playVideo();
			// video.seekTo(1265);
			cover.addEventListener("click", cover.onEvent);
			// document.addEventListener("touchstart",onTouchDocument);
		}
		cover.css = new ResponsiveCSS(".wrap-embed .cover", {opacity:1});
		cover.onEvent = function(evt) {
			switch(evt.type) {
				case "click":
					switch(video.getPlayerState()){

						case YT.PlayerState.CUED:
							// if(!isLivePlayed){
							// 	isLivePlayed = true ;
							// 	// Tracking.all("bingo-live-app-view", BingoCard.hash , "play-start " + new Date().getTime() );
							// }
							// video.seekTo(15850);
							video.playVideo();
							break;

						case YT.PlayerState.PAUSED:
							video.stopVideo();
							video.playVideo();
							break;
					}
					break;
			}
		}

		//YouTube埋め込みを動的に行うために必要なスクリプトの読み込み
		var script = document.createElement('script');
		script.src = "https://www.youtube.com/iframe_api";
		document.body.appendChild(script) ;


		//メモ
		//・埋め込み動画は別タブに移動するとPAUSEDの状態になる
		function onPlayerStateChange(evt) {

			switch( evt.data )
			{
				case YT.PlayerState.UNSTARTED : //-1
					// console.log("YT.PlayerState.UNSTARTED");
					break;

				case YT.PlayerState.BUFFERING : //3
					// console.log("YT.PlayerState.BUFFERING");
					if( isLivePlayed ){
						return ;
					}
					isLivePlayed = true ;
					Tween.add.update(cover.css, {opacity:0, time:0.3, transition:"linear", delay:0.3}, {onUpdate:cover.css.update, onComplete:function(){cover.css.display="none";cover.css.update();} });
					break;

				case YT.PlayerState.PLAYING : //1
					goodjobContainer.style.pointerEvents = "auto" ;
					goodjobContainer.style.display = "";
					// console.log("YT.PlayerState.PLAYING");
					Tween.add.update(cover.css, {opacity:0, time:0.3, transition:"linear", delay:0.3}, {onUpdate:cover.css.update, onComplete:function(){cover.css.display="none";cover.css.update();} });
					break;

				case YT.PlayerState.CUED : //5
					// console.log("YT.PlayerState.CUED");
					break;

				case YT.PlayerState.PAUSED : //2
					// console.log("YT.PlayerState.PAUSED");
					Tween.remove(cover.css);
					cover.css.opacity = 1;
					cover.css.display = "block";
					cover.css.update( );
					// Tween.add.update(cover.css, {opacity:1, time:0.1, transition:"linear"}, {onUpdate:cover.css.update, onStart:function(){cover.css.display="block";cover.css.update();} });
					break;

				case YT.PlayerState.ENDED : //0
					// console.log("YT.PlayerState.ENDED");
					break;
			}
		}


		// var onBeforeUnload = function(evt){
		// 	if(isLivePlayed){
		// 		// Tracking.all("bingo-live-app-view", BingoCard.hash , "play-end " + new Date().getTime() );
		// 	}
		// }
		// window.addEventListener("beforeunload",onBeforeUnload);


		//リロードボタンの設置
		//リロードすることでライブ配信の遅延の解消
		// btn_reload.onEvent = function(evt)
		// {
		// 	switch(evt.type)
		// 	{
		// 		case "click" :
		// 			video.stopVideo();
		// 			video.playVideo();
		// 			if(!isLivePlayed){
		// 				isLivePlayed = true ;
		// 				Tracking.all("bingo-live-app-view", BingoCard.hash , "start " + new Date().getTime() );
		// 			}
		// 			break ;
		// 	}
		// }
		// btn_reload.addEventListener("click",btn_reload.onEvent) ;

	}


//------------------------------------------------------------------------------------------------------------------------------



	var PollingRequest = function() {

		var _this = this, i, temp;

		// var storage = new StorageManager( "grandprix_championship_2018_live" ) ;

		var GET_INTERVAL = 5000;
		var POST_INTERVAL = 10000;


		//---------------------------------------------------------------------------------

		var isStaging = /staging/.test( location.search ) ;

		var getURL = isStaging 	? "https://stg-championship2018.nadeo.net/get/gameinfo/"
								: "https://championship2018.nadeo.net/get/gameinfo/" ;
		var getAPI = function(){
			$.ajax(getURL, {
			// $.ajax("http://stg-championship2018.nadeo.net/get/gameinfo/", {
			// $.ajax("./assets/index/json/sample.json", {
				type: "GET",
				dataType: "json",
				success:function(data){

					// switch( data.status ){
					// 	case 0 : // 未開催
					// 		Message.show();
					// 		GoodjobCount.hide();
					// 		break ;

					// 	case 1 : // 開催集計中
					// 		Message.hide();
					// 		GoodjobCount.show();
					// 		GoodjobCount.applyAPIData(data);
					// 		break ;

					// 	case 2 : // 開催中集計停止
					// 		Message.hide();
					// 		GoodjobCount.show();
					// 		GoodjobCount.applyAPIData(data);
					// 		break ;
					// }
					// console.log("GET：",data) ;
					StateManager.check( data );

					getAPI.timeoutID = setTimeout( getAPI.reload, GET_INTERVAL );
				},
				error:function(evt, type, code){
					getAPI.timeoutID = setTimeout( getAPI.reload, GET_INTERVAL );
				}
			} ) ;
		}
		getAPI.reload = function(){
			window.requestAnimationFrame(getAPI);
		}
		getAPI.timeoutID = setTimeout( getAPI.reload, GET_INTERVAL*Math.random() );


		//---------------------------------------------------------------------------------

		var postURL = isStaging ? "https://stg-championship2018.nadeo.net/put/goodjob/"
								: "https://championship2018.nadeo.net/put/goodjob/" ;

		var putAPI = function(){
			// $.ajax("https://bingo.monster-strike.com/balls_unstable.json?update="+(new Date()).getTime()+"&id="+_hash, {

			var dataObj = GoodjobCount.createPostData();

			if( !dataObj ){
				putAPI.timeoutID = setTimeout( putAPI.reload, POST_INTERVAL );
				// console.log("POST：送信するデータがないのでスキップしました。");
				return ;
			}

			console.log(dataObj);

			// $.ajax("http://stg-championship2018.nadeo.net/put/gameinfo/", {
			$.ajax(postURL, {
				type: "POST",
				data: dataObj,
				success:function(data){
					console.log(data);
					putAPI.timeoutID = setTimeout( putAPI.reload, POST_INTERVAL );
				},
				error:function(evt, type, code){
					putAPI.timeoutID = setTimeout( putAPI.reload, POST_INTERVAL );
				}
			} ) ;
		}
		putAPI.reload = function(){
			window.requestAnimationFrame(putAPI);
		}
		PollingRequest.postSudden = function(){
			var dataObj = GoodjobCount.createPostData();

			if( !dataObj ){
				putAPI.timeoutID = setTimeout( putAPI.reload, POST_INTERVAL );
				// console.log("POST：送信するデータがないのでスキップしました。");
				return ;
			}

			console.log(dataObj);

			// $.ajax("http://stg-championship2018.nadeo.net/put/gameinfo/", {
			$.ajax(postURL, {
				type: "POST",
				data: dataObj,
				success:function(data){
					console.log(data);
				},
				error:function(evt, type, code){
				}
			} ) ;
		}
		putAPI.timeoutID = setTimeout( putAPI.reload, POST_INTERVAL*Math.random() );


		//テスト用関数
		//JSONデータをストリングで渡せる
		// window.sendData = function(data){
		// 	console.log(data) ;
		// 	BingoCard.ballData = JSON.parse( data ) ;
		// 	applyJSON() ;
		// }
	}


//------------------------------------------------------------------------------------------------------------------------------


	// var BingoCard = function() {

	// 	var _this = this, i, temp;

	// 	var _cardNum ;
	// 	var _chanceNum ;


	// 	//セッションストレージにsearchの情報を保持
	// 	//遷移時にsearchの値を持っていなかったらストレージから引き出す
	// 	BingoCard.cardData = location.search;
	// 	try{
	// 		if(BingoCard.cardData){
	// 			if(sessionStorage && sessionStorage.setItem){
	// 				sessionStorage.setItem('winter2017_bingo_search', BingoCard.cardData) ;
	// 			}
	// 		}
	// 		else{
	// 			if(sessionStorage && sessionStorage.setItem){
	// 				BingoCard.cardData = sessionStorage.getItem('winter2017_bingo_search') ;
	// 			}
	// 		}
	// 	}catch(err){
	// 	}
	// 	//URLからseachを外す
	// 	try{
	// 		history.replaceState(null,null,"/promotion/winter2017/bingo_live.html");
	// 	}catch(err){
	// 	}


	// 	//遷移時パラメータがあったらカードの準備
	// 	if( BingoCard.cardData ){

	// 		var search_split = BingoCard.cardData.replace( /\?/ , "" ).split( "&" ) ;
	// 		var query_obj = {} ;
	// 		for( i = 0 ; i < search_split.length ; i++ ){
	// 			var temp_arr = search_split[i].split( "=" ) ;
	// 			query_obj[temp_arr[0]] = temp_arr[1].split( "," ) ;
	// 		}

	// 		_cardNum = query_obj.bingo_card ;
	// 		_chanceNum = query_obj.chance ;
	// 	}


	// 	//以下の場合キャンペーンサイトにリダイレクト
	// 	//・カードのパラメータを持っていない
	// 	//・必要なパラメータが揃っていない
	// 	//・カードのパラメータの形式が合っていない
	// 	if( !BingoCard.cardData || !_cardNum || !_chanceNum || _cardNum.length != 25 || _chanceNum.length != 3 ){
	// 		location.href = "/promotion/winter2017/";
	// 	}


	// 	//ユニークのハッシュの準備
	// 	//トラッキングのためにビンゴカードを元に固有のIDを作成する
	// 	var ZERO = "0" ;
	// 	function to00digit( num ) {
	// 		if( !num )	num = 0 ;
	// 		var str = String(num) ;
	// 		while( str.length < 2 ) {
	// 			str = ZERO + str ;
	// 		}
	// 		return str ;
	// 	}
	// 	var _hash = "" ;
	// 	for( i = 0 ; i < _cardNum.length ; i++ ) {
	// 		_hash = _hash + to00digit( _cardNum[i] ) ;
	// 	}
	// 	for( i = 0 ; i < _chanceNum.length ; i++ ) {
	// 		_hash = _hash + to00digit( _chanceNum[i] ) ;
	// 	}
	// 	if( /localhost:4005|monster-strike\.com\.tw/.test(location.href) ) {
	// 		_hash = "tw" + _hash ;
	// 	}else {
	// 		_hash = "jp" + _hash ;
	// 	}
	// 	console.log(_hash);
	// 	BingoCard.hash = _hash ;


	// 	//ビンゴカードの準備
	// 	//temp_glowをクローンしてそれぞれの<li>タグの点灯用のDOMをappendする
	// 	var temp_glow = document.createElement("div");
	// 	temp_glow.className = "glow" ;
	// 	var bingo_card = document.getElementsByClassName( "card-bingo" )[0] ;
	// 	var bingo_card_li = bingo_card.getElementsByTagName( "li" ) ;
	// 	for( i = 0 ; i < bingo_card_li.length ; i++ ){
	// 		bingo_card_li[i].className = "n" + _cardNum[i] ;
	// 		bingo_card_li[i].num = _cardNum[i] ;
	// 		bingo_card_li[i].defClassName = bingo_card_li[i].className ;
	// 		bingo_card_li[i].appendChild( temp_glow.cloneNode() ) ;
	// 	}


	// 	//チャンスカードの準備
	// 	var onemorechance_card = document.getElementsByClassName( "card-onemorechance" )[0] ;
	// 	var onemorechance_card_li = onemorechance_card.getElementsByTagName( "li" ) ;
	// 	for( i = 0 ; i < onemorechance_card_li.length ; i++ ){
	// 		onemorechance_card_li[i].className = "n" + _chanceNum[i] ;
	// 		onemorechance_card_li[i].num = _chanceNum[i] ;
	// 		onemorechance_card_li[i].defClassName = onemorechance_card_li[i].className ;
	// 		onemorechance_card_li[i].appendChild( temp_glow.cloneNode() ) ;
	// 	}


	// 	//---------------------------------------------------------------------------------


	// 	//読み込んだJSONを画面に反映
	// 	//万が一間違ったデータ反映されて、すぐJSONに修正が入った場合も、
	// 	//画面に反映されるように、毎回すべての番号を判定してアップデートする
	// 	var isFirstSetting = true ;
	// 	var CALLED = " called" ;
	// 	var applyJSON = function(){

	// 		var delay = 0 ;
	// 		var delayInterval = isFirstSetting ? 0 : 0.3;
	// 		isFirstSetting = false ;

	// 		Call.remove(_this);

	// 		for( i = 0 ; i < bingo_card_li.length ; i++ ){

	// 			if( BingoCard.ballData.bingo_ball_ids.indexOf( Number(bingo_card_li[i].num) ) != -1 ){
	// 				if( bingo_card_li[i].className == bingo_card_li[i].defClassName ){
	// 					Call.add(_this,{time:delayInterval*delay},{onComplete:setNumber,onCompleteParams:[bingo_card_li[i]]});
	// 					delay ++ ;
	// 				}
	// 			}else{
	// 				bingo_card_li[i].className = bingo_card_li[i].defClassName ;
	// 			}
	// 		}

	// 		//ワンモアチャンスは３箇所完全一致のときのみ点灯する
	// 		//判定処理
	// 		var onemoreCount = 0 ;
	// 		for( i = 0 ; i < onemorechance_card_li.length ; i++ ){
	// 			if( BingoCard.ballData.chance_ball_ids[i] == Number(onemorechance_card_li[i].num) ){
	// 				onemoreCount ++ ;
	// 			}
	// 		}
	// 		//３箇所完全一致したので、全点灯
	// 		if( onemoreCount == 3 ) {
	// 			for( i = 0 ; i < onemorechance_card_li.length ; i++ ) {
	// 				Call.add(_this,{time:delayInterval*delay},{onComplete:setNumber,onCompleteParams:[onemorechance_card_li[i]]});
	// 				delay ++ ;
	// 			}
	// 		//はずれのときは全消灯
	// 		}else {
	// 			for( i = 0 ; i < onemorechance_card_li.length ; i++ ) {
	// 				onemorechance_card_li[i].className = onemorechance_card_li[i].defClassName ;
	// 			}
	// 		}
	// 	}
	// 	var setNumber = function(target){
	// 		target.className = target.defClassName + CALLED ;
	// 	}


	// 	//JSONデータを読み込みに行く
	// 	//・最初の１回はすぐに読み込みにいく
	// 	//・タブが裏に回ったときに無駄に画面を更新しないために、再度読み込みのtimeoutの前に一度requestAnimationFrameを挟む
	// 	//・ユーザーごとに別のタイミングでリクエストが飛ぶように、ポーリングを行う
	// 	var reloadInterval = 1000 * 15 ;
	// 	var myTiming ;
	// 	var count ;
	// 	try{
	// 		if(localStorage && localStorage.setItem){
	// 			myTiming = Number( localStorage.getItem('winter2017_bingo_my_timing') );
	// 			count = Number( localStorage.getItem('winter2017_bingo_count') );

	// 			if( !myTiming || !count )
	// 			{
	// 				myTiming = ( reloadInterval*Math.random() ) | 0;
	// 				count = Math.floor( (new Date().getTime()+myTiming) / reloadInterval );
	// 				localStorage.setItem('winter2017_bingo_my_timing',myTiming) ;
	// 				localStorage.setItem('winter2017_bingo_count',count) ;
	// 			}
	// 		}
	// 		else
	// 		{
	// 			myTiming = ( reloadInterval*Math.random() ) | 0;
	// 			count = Math.floor( (new Date().getTime()+myTiming) / reloadInterval );
	// 		}
	// 	}catch(err){
	// 		myTiming = ( reloadInterval*Math.random() ) | 0;
	// 		count = Math.floor( (new Date().getTime()+myTiming) / reloadInterval );
	// 	}


	// 	var loadJSON = function(){
	// 		// $.ajax("https://bingo.monster-strike.com/balls_unstable.json?update="+(new Date()).getTime()+"&id="+_hash, {
	// 		$.ajax("https://bingo.monster-strike.com/balls.json?update="+(new Date()).getTime()+"&id="+_hash, {
	// 			dataType:"text",
	// 			success:function(data){

	// 				console.log("data update:"+data) ;
	// 				BingoCard.ballData = JSON.parse(data) ;
	// 				applyJSON( ) ;
	// 				window.requestAnimationFrame(loadJSON.reloadCheck.interval);

	// 				try{
	// 					if(localStorage && localStorage.setItem){
	// 						localStorage.setItem('winter2017_bingo_ball_data', data);
	// 					}
	// 				}catch(err){
	// 				}
	// 			},
	// 			error:function(evt, type, code){

	// 				window.requestAnimationFrame(loadJSON.reloadCheck.interval);
	// 			}
	// 		} ) ;
	// 	}
	// 	loadJSON.reloadCheck = function(){
	// 		var now = Math.floor( (new Date().getTime()+myTiming) / reloadInterval );
	// 		if( now != count ){
	// 			loadJSON() ;
	// 			count = now ;
	// 			try{
	// 				if(localStorage && localStorage.setItem){
	// 					localStorage.setItem('winter2017_bingo_count',count);
	// 				}
	// 			}catch(err){
	// 			}
	// 		}else{
	// 			window.requestAnimationFrame(loadJSON.reloadCheck.interval);
	// 		}
	// 	}
	// 	loadJSON.reloadCheck.interval = function(){
	// 		loadJSON.checkID = setTimeout(loadJSON.reloadCheck, 1000);
	// 	}
	// 	loadJSON.prevRequestTime ;
	// 	loadJSON.checkID ;


	// 	//初回遷移時は、必ずJSONを読み込みにいく
	// 	//２回目以降はlocalStorageのデータを再現する
	// 	BingoCard.ballData ;
	// 	try{
	// 		if(sessionStorage && sessionStorage.setItem){
	// 			var data = localStorage.getItem('winter2017_bingo_ball_data');
	// 			BingoCard.ballData = JSON.parse(data) ;
	// 		}

	// 		if(BingoCard.ballData){
	// 			loadJSON.prevRequestTime = new Date().getTime();
	// 			applyJSON();
	// 			loadJSON.reloadCheck() ;
	// 		}else{
	// 			loadJSON();
	// 		}
	// 	}catch(err){
	// 		loadJSON();
	// 	}


	// 	//---------------------------------------------------------------------------------


	// 	//テスト用関数
	// 	//JSONデータをストリングで渡せる
	// 	window.sendData = function(data){
	// 		console.log(data) ;
	// 		BingoCard.ballData = JSON.parse( data ) ;
	// 		applyJSON() ;
	// 	}
	// }


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;

